/*
Copyright 2026 ВИН СОЛЮШЕНС

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { useTranslation } from "react-i18next";

import { BackgroundSelection } from "./BackgroundSelection";
import {
  tileShape,
  televisionIntensity,
  useSetting,
  type TileShape,
} from "./settings";

export const VideoEffects: FC = () => {
  const { t } = useTranslation();
  const [shape, setShape] = useSetting(tileShape);
  const [intensity, setIntensity] = useSetting(televisionIntensity);
  return (
    <div>
      <fieldset>
        <legend>{t("video_effects.style")}</legend>
        {(["rectangle", "crt", "tv"] as TileShape[]).map((value) => (
          <label key={value} style={{ display: "block", padding: "8px" }}>
            <input
              type="radio"
              name="video-style"
              value={value}
              checked={shape === value}
              onChange={() => setShape(value)}
            />
            {t(`video_effects.${value}`)}
          </label>
        ))}
      </fieldset>
      {shape === "tv" && (
        <label>
          {t("video_effects.intensity")}
          <input
            type="range"
            min={0}
            max={0.5}
            step={0.05}
            value={intensity}
            onChange={(e) => setIntensity(Number(e.target.value))}
          />
        </label>
      )}
      <p>{t("video_effects.scope")}</p>
      <BackgroundSelection />
    </div>
  );
};
